import PropTypes from "prop-types";
import VStack from "shared/components/layout/stack/VStack";
import Form from "shared/components/inputs/form/Form";
import Text from "shared/components/data-display/text/Text";
import ModalActions from "shared/components/feedback/modals/ModalActions";
import { sendNotification } from "shared/components/feedback/notification/notification";

import useAccessGroups from "./useAccessGroups";
import { useState } from "react";

const AccessGroupDeleteForm = ({ accessGroupIdToDelete, onClose }) => {
    const { accessGroups, deleteAccessGroup } = useAccessGroups();
    const [inProgress, setInProgress] = useState(false);

    const currentAccessGroupData = accessGroups.data.find(
        (accessGroup) => accessGroup.id === accessGroupIdToDelete
    );

    if (!currentAccessGroupData) {
        return <div>Could not find access group</div>;
    }

    const modifier = deleteAccessGroup;

    const onSubmit = async () => {
        setInProgress(true);
        const allData = { groupId: accessGroupIdToDelete };
        await modifier.mutateAsync(allData);
        setInProgress(false);
        onClose();
        sendNotification(
            <>
                <strong> {currentAccessGroupData.name} </strong> have been
                deleted
            </>
        );
    };
    return (
        <Form onSubmit={onSubmit}>
            <VStack spacing="Three">
                <Text variant="Body_1_1" color="Gray_2">
                    Are you sure you'd like to delete{" "}
                    <strong> {currentAccessGroupData.name} </strong>?
                </Text>
                <ModalActions
                    primaryAction={{
                        type: "submit",
                        label: "Yes, Delete",
                        disabled: inProgress,
                    }}
                    secondaryAction={{
                        type: "button",
                        label: "Cancel",
                        to: "?action=edit&id=" + accessGroupIdToDelete,
                        disabled: inProgress,
                    }}
                />
            </VStack>
        </Form>
    );
};

AccessGroupDeleteForm.propTypes = {
    accessGroupIdToDelete: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired
};

export default AccessGroupDeleteForm;
